import React from 'react'
import styled from 'styled-components'
import {
  space as spaceLayout,
  layout,
  compose,
  SpaceProps,
  LayoutProps,
  PositionProps,
} from 'styled-system'
import { v4 } from 'uuid'

import { Icon, TextBody, Box } from '@ally/metronome-ui'
import { deprecated } from '@ally/metronome-icons'
import { HelperRuleProps } from '@ally/forms'

export interface ContextualHelpProps {
  name: string
  className?: string
  isDisplayed?: boolean
  directions: HelperRuleProps[]
  fieldInput?: string
  id: string // NOTE: used for linking to an input field via aria-describedby
}

const ContextualHelpWrapper = styled(Box)`
  ${(): string => `
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
  `}
`

const SuccessTextBody = styled(TextBody)`
  color: #0b8100;
`

const ContextualHelp: React.FC<ContextualHelpProps> = ({
  className,
  isDisplayed,
  directions,
  fieldInput,
  id,
}) => {
  if (isDisplayed) {
    return (
      <ContextualHelpWrapper
        id={id}
        className={`${className} field-rule-helper`}
      >
        {directions.map(
          (direction): React.ReactNode => {
            const isSuccessful = direction.isValid(fieldInput || '')
            return (
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                key={v4()}
              >
                {isSuccessful && (
                  <Icon
                    icon={deprecated.muiCheckMark}
                    unsupportedCustomWidth={15}
                    unsupportedCustomHeight={15}
                    fill="success"
                    mr="xxs"
                  />
                )}
                {isSuccessful ? (
                  <SuccessTextBody tag="p" size="sm">
                    {direction.text}
                  </SuccessTextBody>
                ) : (
                  <TextBody tag="p" size="sm">
                    {direction.text}
                  </TextBody>
                )}
              </Box>
            )
          },
        )}
      </ContextualHelpWrapper>
    )
  }

  return null
}

type StyledContextualHelpProps = PositionProps &
  SpaceProps &
  LayoutProps & { id: string }
const StyledContextualHelp = styled(ContextualHelp)<StyledContextualHelpProps>`
  ${({ theme: { space } }): string => `
    margin-top: ${space.xs};
  `}
  align-self: start;
  min-width: 235px;
  ${compose(spaceLayout, layout)}
`

export const InputFieldRuleHelper: React.FC<ContextualHelpProps> = ({
  // NOTE: this component is a REFACTOR of PasswordRuleHelper.tsx intended to replace it
  name,
  className,
  directions,
  isDisplayed = true,
  fieldInput,
  id,
}) => {
  return (
    <StyledContextualHelp
      name={name}
      className={className}
      isDisplayed={isDisplayed}
      directions={directions}
      fieldInput={fieldInput}
      id={id}
    />
  )
}
